import store from "../store";
import VueMatomo from "vue-matomo";

const MATOMO_HOST = "https://matomo.cultuzz.com/";

let matomoInitialized = false;

const getActiveConfig = () => {
  const { currentConfig, defaultConfig } = store.state.config;
  return currentConfig || defaultConfig || {};
};

const toPositiveInt = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const getMatomoSiteId = (config = getActiveConfig()) =>
  toPositiveInt(config?.matomoSiteId);

export const getMatomoReservationGoalId = (config = getActiveConfig()) =>
  toPositiveInt(config?.matomoReservationGoalId);

const waitForMatomo = () => {
  if (window.Piwik) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const started = Date.now();
    const interval = setInterval(() => {
      if (window.Piwik || Date.now() - started >= 5000) {
        clearInterval(interval);
        resolve();
      }
    }, 50);
  });
};

export const isMatomoReady = () => matomoInitialized && Boolean(window._paq);

export const applyMatomoConfig = (config = getActiveConfig()) => {
  const siteId = getMatomoSiteId(config);
  if (!siteId || !window._paq) {
    return;
  }

  window._paq.push(["setSiteId", siteId]);
};

export const initMatomo = async (Vue, config = getActiveConfig()) => {
  const siteId = getMatomoSiteId(config);
  if (!siteId) {
    return;
  }

  if (!matomoInitialized) {
    Vue.use(VueMatomo, {
      host: MATOMO_HOST,
      siteId,
      trackInitialView: false,
    });
    matomoInitialized = true;
    await waitForMatomo();
    return;
  }

  applyMatomoConfig(config);
  await waitForMatomo();
};

export const trackMatomoPageView = () => {
  if (!isMatomoReady()) {
    return;
  }

  window._paq.push(["setCustomUrl", window.location.href]);
  window._paq.push(["setDocumentTitle", document.title]);
  window._paq.push(["trackPageView"]);
};

export const trackMatomoReservationGoal = (config = getActiveConfig()) => {
  const goalId = getMatomoReservationGoalId(config);
  if (!goalId || !isMatomoReady()) {
    return;
  }

  window._paq.push(["trackGoal", goalId]);
};
